import { Characteristics } from "../Characteristics";

export class FighterType {
  id!: string;
  name!: string;
  cost!: number;
  characteristics!: Characteristics;
}
